'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  overflow: hidden;\n  white-space: nowrap;\n  font-family: \'Nunito Sans\', \'Helvetica Neue\', HelveticaNeue, Helvetica, Arial, sans-serif;\n  z-index: 1000;\n'], ['\n  overflow: hidden;\n  white-space: nowrap;\n  font-family: \'Nunito Sans\', \'Helvetica Neue\', HelveticaNeue, Helvetica, Arial, sans-serif;\n  z-index: 1000;\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  list-style-type: none;\n  padding-inline-start: 0;\n  padding-left: 0px;\n  margin: 4px 0;\n'], ['\n  list-style-type: none;\n  padding-inline-start: 0;\n  padding-left: 0px;\n  margin: 4px 0;\n']),
    _templateObject3 = (0, _taggedTemplateLiteral3.default)(['\n  margin: 0px;\n  position: relative;\n  ', '\n  &:hover {\n    border-radius: 25px;\n    span {\n      color: #6e0ad6;\n    }\n    svg path {\n      color: #6e0ad6;\n    }\n  }\n'], ['\n  margin: 0px;\n  position: relative;\n  ', '\n  &:hover {\n    border-radius: 25px;\n    span {\n      color: #6e0ad6;\n    }\n    svg path {\n      color: #6e0ad6;\n    }\n  }\n']),
    _templateObject4 = (0, _taggedTemplateLiteral3.default)(['\n      background-color: #f3eef5;\n      border-radius: 25px;\n      span {\n        color: #6e0ad6;\n      }\n      svg path {\n        color: #6e0ad6;\n      }\n    '], ['\n      background-color: #f3eef5;\n      border-radius: 25px;\n      span {\n        color: #6e0ad6;\n      }\n      svg path {\n        color: #6e0ad6;\n      }\n    ']),
    _templateObject5 = (0, _taggedTemplateLiteral3.default)(['\n  min-width: 104px;\n  height: 48px;\n  & > span {\n    margin-left: 24px;\n    font-size: 16px;\n    font-weight: normal;\n  }\n'], ['\n  min-width: 104px;\n  height: 48px;\n  & > span {\n    margin-left: 24px;\n    font-size: 16px;\n    font-weight: normal;\n  }\n']),
    _templateObject6 = (0, _taggedTemplateLiteral3.default)(['\n  flex: 1;\n  width: 287px;\n'], ['\n  flex: 1;\n  width: 287px;\n']); /* eslint-disable no-undef */
/* eslint react/prop-types: 0 */
/* eslint-disable no-restricted-globals */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CreditCard = require('@olxbr/olx-icons/dist/System/CreditCard');

var _CreditCard2 = _interopRequireDefault(_CreditCard);

var _Shield = require('@olxbr/olx-icons/dist/System/Shield');

var _Shield2 = _interopRequireDefault(_Shield);

var _Clipboard = require('@olxbr/olx-icons/dist/System/Clipboard');

var _Clipboard2 = _interopRequireDefault(_Clipboard);

var _Bell = require('@olxbr/olx-icons/dist/System/Bell');

var _Bell2 = _interopRequireDefault(_Bell);

var _Award = require('@olxbr/olx-icons/dist/System/Award');

var _Award2 = _interopRequireDefault(_Award);

var _MyLinkBox = require('./MyLinkBox');

var _MyLinkBox2 = _interopRequireDefault(_MyLinkBox);

var _staticUrl = require('../../../config/staticUrl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Nav = _styledComponents2.default.nav(_templateObject);

var Ul = _styledComponents2.default.ul(_templateObject2);

var Li = _styledComponents2.default.li(_templateObject3, function (props) {
  return props.selected && (0, _styledComponents.css)(_templateObject4);
});

var LinkBoxOfSideMenuItem = (0, _styledComponents2.default)(_MyLinkBox2.default)(_templateObject5);

var SideMenuWrapper = _styledComponents2.default.div(_templateObject6);

var SideMenu = function (_React$PureComponent) {
  (0, _inherits3.default)(SideMenu, _React$PureComponent);

  function SideMenu(props) {
    (0, _classCallCheck3.default)(this, SideMenu);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SideMenu.__proto__ || (0, _getPrototypeOf2.default)(SideMenu)).call(this, props));

    _this.state = {
      selectedMenu: props.selectedMenu === '' ? 'meu-cadastro' : props.selectedMenu
    };
    return _this;
  }

  (0, _createClass3.default)(SideMenu, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var selectedMenu = this.state.selectedMenu;


      var clickMenu = function clickMenu(ev, menuSelection) {
        ev.preventDefault();
        _this2.setState({ selectedMenu: menuSelection });
        window.location.href = window.location.origin + '/' + menuSelection;
      };

      return _react2.default.createElement(
        SideMenuWrapper,
        null,
        _react2.default.createElement(
          Nav,
          this.props,
          _react2.default.createElement(
            Ul,
            null,
            _react2.default.createElement(
              Li,
              { selected: selectedMenu === 'meu-cadastro' },
              _react2.default.createElement(
                LinkBoxOfSideMenuItem,
                {
                  innerRender: 'Meu cadastro',
                  onClick: function onClick(ev) {
                    return clickMenu(ev, 'meu-cadastro', _staticUrl.minhaConta);
                  }
                },
                _react2.default.createElement(_Clipboard2.default, { width: 24, height: 24 })
              )
            ),
            _react2.default.createElement(
              Li,
              { selected: selectedMenu === 'seguranca' },
              _react2.default.createElement(
                LinkBoxOfSideMenuItem,
                {
                  innerRender: 'Seguran\xE7a e privacidade',
                  onClick: function onClick(ev) {
                    return clickMenu(ev, 'seguranca');
                  }
                },
                _react2.default.createElement(_Shield2.default, { width: 24, height: 24 })
              )
            ),
            _react2.default.createElement(
              Li,
              { selected: selectedMenu === 'pagamentos' },
              _react2.default.createElement(
                LinkBoxOfSideMenuItem,
                {
                  innerRender: 'Pagamentos',
                  onClick: function onClick(ev) {
                    return clickMenu(ev, 'pagamentos');
                  }
                },
                _react2.default.createElement(_CreditCard2.default, { width: 24, height: 24 })
              )
            ),
            _react2.default.createElement(
              Li,
              { selected: selectedMenu === 'comunicacoes' },
              _react2.default.createElement(
                LinkBoxOfSideMenuItem,
                {
                  innerRender: 'Comunica\xE7\xF5es',
                  onClick: function onClick(ev) {
                    return clickMenu(ev, 'comunicacoes');
                  }
                },
                _react2.default.createElement(_Bell2.default, { width: 24, height: 24 })
              )
            ),
            _react2.default.createElement(
              Li,
              { selected: selectedMenu === 'meu-nivel' },
              _react2.default.createElement(
                LinkBoxOfSideMenuItem,
                {
                  innerRender: 'Meu n\xEDvel',
                  onClick: function onClick(ev) {
                    return clickMenu(ev, 'meu-nivel');
                  }
                },
                _react2.default.createElement(_Award2.default, { width: 24, height: 24 })
              )
            )
          )
        )
      );
    }
  }]);
  return SideMenu;
}(_react2.default.PureComponent);

SideMenu.defaultProps = {
  selectedMenu: 'meu-cadastro'
};

SideMenu.propTypes = {
  selectedMenu: _propTypes2.default.string
};

exports.default = SideMenu;